<template>
  <div class="object-page-wrapper">
    <div class="page-content d-flex f-column">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">№458</h1>
        <div @click="$router.go(-1)" class="go-back-icon">
          <svg
            class="d-block ml-auto"
            xmlns="http://www.w3.org/2000/svg"
            width="17.999"
            height="18"
            viewBox="0 0 17.999 18"
          >
            <path
              id="Union_9"
              data-name="Union 9"
              d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
              transform="translate(10510 7379)"
              fill="#fefefc"
            />
          </svg>
        </div>
      </div>

      <div class="flat-wrap f-full">
        <div class="flex-container">
          <div class="flex-half p-relative">
            <div class="flat-meta-items">
              <span>Сторона</span>
              <p>Юго-запод</p>
            </div>
            <div class="flat-meta-items">
              <span>Этаж</span>
              <p>7</p>
            </div>
            <div class="flat-meta-items">
              <span>Комнаты</span>
              <p>2</p>
            </div>
            <div class="flat-meta-items">
              <span>Площадь</span>
              <p>
                73,35 м
                <sup>2</sup>
              </p>
            </div>
            <div class="flat-meta-items">
              <span>Высота потолков</span>
              <p>до 2,93 м</p>
            </div>

            <div class="flat-meta-cost">
              <span>
                Цена за м
                <sup>2</sup>
              </span>
              <p>
                15 000 000 сум. / м
                <sup>2</sup>
              </p>
            </div>

            <div class="flat-descr">
              <span>
                Цена за м
                <sub>2</sub>
              </span>
              <p class="cost-line-through">46 000 000 сум.</p>
              <div class="flat-new-cost">
                <h1>45 000 000 сум.</h1>
              </div>

              <button
                aria-haspopup="openPopup"
                type="submit"
                class="form-group__button text-white pointer mb-4"
              >Оставьте заявку</button>
              <span class="d-block">
                Позвонить нам:
                <a
                  href="tel:+998712333330"
                  class="ml-1 text-white"
                >+998 (71) 233 33 30</a>
              </span>
              <!-- <span class="d-block">
                Сохранить:
                <a href="#" class="ml-1 text-white">PDF</a>
              </span> -->
            </div>

            <div class="flat-form p-absolute w-100 h-100" aria-modal="formModal">
              <div class="flat-form__close pointer" aria-hidden="formModal">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.999"
                  height="18"
                  viewBox="0 0 17.999 18"
                >
                  <path
                    id="Union_9"
                    data-name="Union 9"
                    d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
                    transform="translate(10510 7379)"
                    fill="#fefefc"
                  />
                </svg>
              </div>
              <span class="flat-form__title">Оставьте заявку</span>
              <Form />
            </div>
          </div>
          <div class="flex-half">
            <div class="flat-img">
              <img src="/img/5.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomNavigation />
  </div>
</template>

<script>
import BottomNavigation from "./components/BottomNavigation";
import Form from "@/components/Form";
export default {
  components: {
    BottomNavigation,
    Form
  },
  mounted() {
    const _button = document.querySelector('[aria-haspopup="openPopup"]'),
      _modal = document.querySelector('[aria-modal="formModal"]'),
      _close = document.querySelector('[aria-hidden="formModal"]');

    _button.addEventListener("click", function() {
      _modal.classList.add("flat-form__active");
    });

    _close.addEventListener("click", function() {
      _modal.classList.remove("flat-form__active");
    });
  }
};
</script>

<style></style>
